// Light-weight mock forecaster for 3 months horizon.
export type ForecastInput = { lastValues: number[] };
export type ForecastOutput = { next: number[] };

export function forecastSeries(i: ForecastInput): ForecastOutput {
  const arr = i.lastValues.slice(-6);
  const mean = arr.reduce((a,b)=>a+b,0)/Math.max(1,arr.length);
  const next = [1,2,3].map((m)=> parseFloat((mean*(1 + (Math.random()-0.5)*0.1)).toFixed(0)));
  return { next };
}



















